import axios from "axios";

export const importFolder = async (folderPath) => {
    const  request = {
        folder: folderPath
    }
    const formBody = Object.keys(request).map(key =>      encodeURIComponent(key) + '=' + encodeURIComponent(request[key])).join('&');
    console.log("Browse Folder Request: {}", encodeURIComponent(request));
    return await axios.post(process.env.REACT_APP_BACKEND_SERVER_URL + process.env.REACT_APP_BROWSE_URL, formBody, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        }
    })
}